import { ApiRequest } from "src/models/api.request";
import GnlRaporSorguDTO from "src/models/KararDestek/GnlRaporSorguDTO";
import ReportMailRequest from "src/models/Print/ReportMailRequest";
import VwKullaniciEkranraporDTO from "src/models/Print/VwKullaniciEkranraporDTO";
import KullaniciPrinterDTO from "src/models/Printer/KullaniciPrinterDTO";
import { PrinterState } from "src/store/Slices/Base/PrinterSlice";
import api from "../core/api";
import { env } from "src/env";
import VwRaporDijitalImzaDTO from "src/models/DijitalRapor/VwRaporDijitalImzaDTO";
import HastaDijitalRaporKaydet from "src/models/DijitalRapor/HastaDijitalRaporKaydet";

interface IRaporSorguRes {
  sablon: any
  sorgu: any
}
interface IRaporSorguReq {
  pkRaporSorgu: number
  parametre: Array<string>
}


export const PrinterApi = api.injectEndpoints({
  endpoints: builder => ({
    getPcInfo: builder.query<PrinterState, null>({
      query: () => ({
        url: env.REACT_APP_BARKOD_API_URL + "/pc-info",
        method: "GET"
      }),
      providesTags: ["PcInfo"]
    }),
    printpdf: builder.query<Blob, {
      printer: string,
      data: string
    }>({
      query: (request) => ({
        url: env.REACT_APP_BARKOD_API_URL + "/print-pdf",
        method: "POST",
        body: JSON.stringify(request)
      })
    }),
    getKullaniciPrinter: builder.query<Array<KullaniciPrinterDTO>, { macAddress: string, kullaniciId: number }>({
      query: (request) => {
        const req: ApiRequest<KullaniciPrinterDTO> = {
          paging: false,
          filters: {
            groupOperator: "and",
            predicates: [
              { fieldName: "macAddress", operator: "=", value1: request.macAddress },
              { fieldName: "kullaniciId", operator: "=", value1: request.kullaniciId },
            ]
          }
        }
        return {
          url: "KullaniciPrinterDTO/find",
          method: "POST",
          body: req
        }
      },
      providesTags: ["KullaniciPrinter"]
    }),
    getRaporSorguSablon: builder.query<Array<string>, { pkRaporsorgu: number, parameters: Array<any> }>({
      query: (request) => {
        return {
          url: "raporlama/GetRaporSorguSablon/" + request.pkRaporsorgu,
          method: "POST",
          body: JSON.stringify(request.parameters)
        }
      },
    }),
    getVwKullaniciEkranrapor: builder.query<Array<VwKullaniciEkranraporDTO>, { kullaniciId: number, modulId: number, ekranKodu: string }>({
      query: (request) => ({
        url: "raporlama/GetVwKullaniciEkranrapor",
        method: "GET",
        params: {
          kullaniciId: request.kullaniciId,
          modulId: request.modulId,
          ekranKodu: request.ekranKodu
        }
      }),
      providesTags: ["KullaniciEkranrapor"],
      transformResponse(baseQueryReturnValue, meta, arg) {
        const kullaniciRaporList: Array<VwKullaniciEkranraporDTO> = [];
        baseQueryReturnValue?.forEach(fe => {
          if (!kullaniciRaporList.filter(f => f.pkRaporsorgu === fe.pkRaporsorgu).length) {
            kullaniciRaporList.push(fe)
          }
        })
        return kullaniciRaporList;
      },
    }),
    sabitReportFileWrite: builder.query<string, { pkRaporsorgu: number, parameters: Array<any> }>({
      query: (request) => ({
        url: "raporlama/sabitReportFileWrite/" + request.pkRaporsorgu,
        method: "POST",
        body: JSON.stringify(request.parameters)
      })
    }),
    exportPrintPdf: builder.query<Blob, { pkRaporsorgu: number, req: { parameters: Array<any>, dijitalImza?: string, dijitalImzaBool?: boolean } }>({
      query: (request) => ({
        url: "raporlama/exportPdf/" + request.pkRaporsorgu,
        method: "POST",
        body: JSON.stringify(request.req),
        responseHandler(response) {
          return response.blob()
        }
      })
    }),
    exportPrintFile: builder.query<Blob, { guid: string, type: string }>({
      query: (request) => ({
        url: "raporlama/exportFile/" + request.guid + "/" + request.type,
        method: "POST",
        responseHandler(response) {
          return response.blob()
        }
      })
    }),
    exportPrintMailMessage: builder.query<Blob, ReportMailRequest>({
      query: (request) => ({
        url: "raporlama/exportMailMessage",
        method: "POST",
        body: JSON.stringify(request)
      }),
    }),
    HastaDijitalRaporListesi: builder.query<Array<VwRaporDijitalImzaDTO>, { muracaatId: number }>({
      query: (request) => ({
        url: "raporlama/HastaDijitalRaporListesi",
        method: "GET",
        params: request,
      }),
    }),
    HastaDijitalRaporKaydet: builder.mutation<boolean, HastaDijitalRaporKaydet>({
      query: (request) => ({
        url: "raporlama/HastaDijitalRaporKaydet",
        method: "POST",
        body: JSON.stringify(request),
      }),
    }),
  }),
})

export const {
  useGetPcInfoQuery,
  useGetKullaniciPrinterQuery,
  useGetVwKullaniciEkranraporQuery,
  useLazySabitReportFileWriteQuery,
  useLazyExportPrintPdfQuery,
  useLazyPrintpdfQuery,
  useLazyExportPrintFileQuery,
  useLazyExportPrintMailMessageQuery,
  useGetRaporSorguSablonQuery,
  useLazyHastaDijitalRaporListesiQuery,
  useHastaDijitalRaporKaydetMutation,
} = PrinterApi;